<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <GridPanel
          :url="'/api/v2/content-pages/' + $route.params.contentPageId + '/content-rows'"
          :portal="portal"
          @create-content-block="$router.push('content-rows/'+$event.id+'/content-blocks/create')"
          @edit-content-block="$router.push('content-rows/'+$event.contentRow.id+'/content-blocks/'+$event.contentBlock.id+'/edit')"
      />

      <FormPanel
          :initial="contentPage.attributes"
          headline="Edit Page"
          :errors="errors"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentPages/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'
import GridPanel from "../../../../../../../components/Administration/ContentRows/Panels/Grid.vue";

export default {
  components: {GridPanel, LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    }
  },

  data() {
    return {
      contentPage: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/content-pages/' + this.$route.params.contentPageId).then(response => {
        this.contentPage = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/content-pages/' + this.$route.params.contentPageId, data)
          .then(response => {
            notify.success('The content page was saved')

            this.contentPage = response.data.data
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
